// Content template 1 for influencer focus
export const influencerTemplate1 = `Content creation isn’t just about posting—it’s about showing up, building trust, and still struggling to make it work.

That’s the reality most creators face—until now.

@Aesha and @Ravi are building anchors—a platform where creators finally get what they need:
 → A community that gets them.
 → Brand collaborations that actually pay.

From 1K to 500K followers, creators are joining this exclusive space where they can learn, earn, and grow—without chasing DMs or worrying about payment follow-ups.

It’s rare to see something so aligned with what creators truly need.`;

// Content template 2 for influencer focus
export const influencerTemplate2 = `No creator should grow alone.

But that's how most of them feel—navigating brand deals, content pressure, and constant algorithm changes.

This is where anchors comes in in—built by @Ravi and @Aesha to be a home for creators.

It’s not just a platform. It’s a community + brand collab hub.
 → Collaborate with brands (without cold DMs).
 → Find support from creators who’ve been there.
 → Get discovered, not ignored.

From 1K to 500K followers, creators are finding a real place to belong.
And that changes everything.`;

// Content template 3 for influencer focus
export const influencerTemplate3 = `Being a creator is hard. Getting paid shouldn’t be.

Most creators don’t struggle with content—they struggle with finding brand collabs and a solid community that truly understands the journey.
anchors solves both.

@Ravi and @Aesha are building a space for creators (1K–500K followers) to connect, collaborate, and get paid without the usual chaos.

It’s like LinkedIn, but for creators—without noise, without fluff—just value and visibility.
If you’re a creator and tired of being on the sidelines, this is worth exploring.`;

// Content template 4 for influencer focus
export const influencerTemplate4 = `Tired of chasing brands and DMs that lead nowhere?

Creators are done waiting.

That’s why @Aesha and @Ravi are building anchors—a dedicated platform for creators with 1K–500K followers.
Where they don’t just get brand collaborations, but also become part of a real community.

It’s where creators talk, grow, earn, and help each other get better.
No vague promises. 

No ghosting. 

Just real opportunities for real creators.
If you’ve been looking for your people—this might be it.`;

// Content template for brand focus
export const brandTemplate1 = `people don’t trust ads anymore. They trust creators.\n
The consumer mindset has shifted—people want recommendations, not promotions. Influencers now shape buying decisions, not banner ads.\n
But most companies find influencer marketing too chaotic. Manual workflows, upfront payments, and no clear ROI? It's a mess.\n
That’s where anchors comes in.\n
They’re building a platform that makes influencer marketing feel like running Facebook Ads: ✅ Performance-based\n
- Fully automated\n
- No calls, emails, or negotiation\n
Even a single person can run 50+ campaigns at once.\n
Real results. Real tracking. Real impact.\n
They’ve started with LinkedIn creators and are already rolling out for Instagram, YouTube, and Twitter.\n
Link in comments to explore what they’ve built.\n`;

// Content template for brand focus - second template
export const brandTemplate2 = `Influencer marketing isn’t broken—just outdated.

Most brands still run it manually:

DMs, spreadsheets, delays, uncertainty. And still, they don’t know if it worked.

anchors is trying to fix that.

They’re building a performance-driven influencer marketing platform—think Meta Ads, but for creators.

No upfront payment.

- No negotiation stress.

- Just results.

Brands set their campaign goals. anchors handle the rest—matching, execution, reporting—all, and automated.

They’re starting with LinkedIn and expanding fast. If you've ever run an influencer campaign and felt it wasn’t worth the hassle, you need to see this.

Details in comments 👇`;

// Content template for brand focus - third template
export const brandTemplate3 = `Would you rather see an ad or hear it from someone you trust?

That’s why influencer marketing works. But for brands, executing it feels like solving a puzzle blindfolded.

anchors is building something different.

They’re making influencer campaigns as easy as running a Facebook ad.

 📌 Campaign setup in minutes

 📌 AI picks the best-fit influencers

 📌 Pay only for performance

 📌 Track real-time engagement & sentiment

And yes—no calls, no DMs, no chasing for results.

Right now, they’re live for LinkedIn creators and soon expanding to other platforms.

If you've written off influencer marketing because of execution headaches, it’s worth checking out anchors. Link in comments.`;

// Content template for brand focus - fourth template
export const brandTemplate4 = `Most marketing channels evolved—except influencer marketing.

While ads became data-driven and automated, influencer campaigns stayed stuck in manual mode.

anchors is changing that.

They’re helping brands run influencer campaigns like they run Meta Ads—automated, scalable, and performance-first.

No guesswork. No wasted budgets. No ghosting.

Here’s what they’ve solved:

✔️ Influencer discovery

✔️ ROI-based payments

✔️ Real-time data tracking

✔️ Platform-led collaboration

It’s influencer marketing, finally designed for 2025.

If you’re a marketer or founder tired of rolling the dice on campaigns, anchors might be the alternative you’ve been waiting for.
Link in comments.`;
